module.exports = __webpack_public_path__ + "img/03.8b6a2366.jpg";